// src/components/NavBar.js
import React from "react";
import "./NavBar.css";
import LogoImage from "../../assets/images/clogo.png";
import { HashLink } from "react-router-hash-link";


const NavBar = () => {
  
  return (

    <>
      <header className="top-navbar sticky-top">
        <nav className="navbar navbar-expand-lg ms-auto navbar-light bg-light">
          <div className="container ">
            <a className="navbar-brand " href="/">
              <img
                src={LogoImage}
                alt="logo"
                className="logo-image"
                style={{ width: "180px", height: "auto", objectFit: "contain" }}
              ></img>
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav ms-auto">
                {/* <li className="nav-item "> 
                       <Link  className="nav-link " to="/"> <span className="active-home"> Home
                       </span></Link>
                       </li>              */}
                {/* <Link to="/about"> About Us </Link> */}
                <li className="nav-item">
                  <a className="nav-link" href="/">
                    Home
                  </a>
                </li>
                <li className="nav-item">
                  {" "}
                  <HashLink
                    a
                    className="nav-link text-dark"
                    smooth
                    to="/#features"
                  >
                    Features
                  </HashLink>
                </li>
                <li className="nav-item">
                  <HashLink
                    a
                    className="nav-link text-dark"
                    smooth
                    to="/#mission"
                  >
                    Mission
                  </HashLink>
                </li>
                <li className="nav-item">
                  <HashLink a className="nav-link text-dark" smooth to="/#faq">
                    FAQs
                  </HashLink>
                </li>
                <li className="nav-item">
                  <HashLink
                    a
                    className="nav-link text-dark"
                    smooth
                    to="/#contactUs"
                  >
                    Contact Us
                  </HashLink>
                </li>
                {/* <li className="nav-item"><a className="nav-link" href="/Documentation">Documentation</a></li>    */}
              </ul>
              <ul className="nav navbar-nav navbar-register " id="">
                <li>
                  <a
                    className="hover-btn-new btn-donate text-danger  "
                    href="/#dowload"
                  >
                    <span>Get Kliq</span>
                  </a>
                </li>
              </ul>
              {/* <ul className="nav navbar-nav navbar-right" id="">
                   <li>
                            <Link className="hover-btn-new btn-sign " to="/login"> <span className="active-home"> Sign
                               In
                       </span></Link>
                       </li>                           
               </ul> */}
            </div>
          </div>
        </nav>
      </header>
    </>
  );
};
export default NavBar;
